import { StyleSheet } from 'react-native'
import { color, fontFamily } from '../../../theme'

export const styles = StyleSheet.create({
  container: {
    backgroundColor: color.palette.cream,
    flex: 1
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 10,
    borderBottomColor: '#DDDAD2',
    borderBottomWidth: 1
  },
  text: {
    fontFamily: fontFamily.GTAmericaExtended,
    fontWeight: '700',
    fontSize: 12,
    lineHeight: 14.4
  },
  item: {
    padding: 10
  },
  list: { backgroundColor: color.palette.cream },
  rankSection: { flex: 0.3, padding: 10 },
  userSection: { flex: 1, flexDirection: 'row', alignItems: 'flex-start', width: '60%', padding: 10 },
  chipsSection: { flex: 0.4, paddingVertical: 10 }
})
